import { BookMarkedIcon, ClipboardCheckIcon, FolderOpenIcon, LayersIcon, LightbulbIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  benefit: string;
  value: string;
  icon: LucideIcon;
  wide?: boolean;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: '150 Wine Studies Classroom Activities & Challenges',
    description:
      '150 ready-to-use activity ideas covering foundations, viticulture, winemaking, aging, sensory analysis, wine regions, history and culture, hospitality, and food pairing. Organized by difficulty level and topic.',
    benefit: 'Materials already designed for your classroom: saves hours every quarter.',
    value: 'USD 14',
    icon: FolderOpenIcon,
  },
  {
    number: '02',
    title: 'Wine Studies Assessment Bank',
    description:
      'Comprehensive assessment resources designed to evaluate student learning throughout a wine studies course. Includes diagnostic assessments, progress activities, quizzes, tests, sensory evaluation tasks, performance assessments, rubrics, and scoring criteria.',
    benefit: 'Never build an exam from scratch under pressure again.',
    value: 'USD 14',
    icon: ClipboardCheckIcon,
  },
  {
    number: '03',
    title: '50 Projects & Inquiry-Based Learning Experiences',
    description:
      '50 structured projects and inquiry-based learning experiences that encourage students to research, investigate, analyze evidence, solve problems, collaborate, and apply wine studies concepts to meaningful situations. Each includes driving questions, objectives, procedures, expected outcomes, and assessment criteria.',
    benefit: 'Your students finish the year with real wine studies projects.',
    value: 'USD 14',
    icon: LightbulbIcon,
  },
  {
    number: '04',
    title: 'Wine Terminology & Concept Handbook',
    description:
      'Comprehensive reference handbook covering essential Wine Studies and Oenology terminology and concepts. Designed to help teachers and students quickly review vocabulary related to viticulture, winemaking, aging, sensory analysis, wine regions, history, hospitality, culture, and professional practice.',
    benefit: 'Project it in class and your students instantly understand complex wine concepts.',
    value: 'USD 14',
    icon: BookMarkedIcon,
  },
  {
    number: '05',
    title: '100 Wine Case Studies & Real-World Scenarios',
    description:
      '100 case studies and realistic scenarios covering vineyard management decisions, production challenges, aging considerations, sensory analysis, wine regions, history and culture, hospitality situations, and integrated professional scenarios.',
    benefit:
      'Students work through Observe → Identify → Analyze → Connect → Decide → Justify → Reflect, transforming theoretical knowledge into practical reasoning.',
    value: 'USD 14',
    icon: LayersIcon,
    wide: true,
  },
];
